module.exports = __webpack_public_path__ + "static/dev-cec35c5bf115ed06ec6f268fb79ae10e.svg";